module.exports = __webpack_public_path__ + "img/6.503b15f2.jpeg";